import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { getLeaderboard, setLeaderboardHidden, type LeaderboardExam } from './api';

export function useLeaderboard(exam: LeaderboardExam) {
  const { state } = useAuthContext();
  return useQuery({
    queryKey: ['leaderboard', state.user?.id, exam],
    queryFn: ({ signal }) => getLeaderboard(exam, signal),
    enabled: Boolean(state.user?.id),
  });
}

/** Hides or shows the learner on every board, then reloads the boards. */
export function useLeaderboardVisibility() {
  const { state } = useAuthContext();
  const client = useQueryClient();
  return useMutation({
    mutationFn: (hidden: boolean) => setLeaderboardHidden(hidden),
    onSettled: () => client.invalidateQueries({ queryKey: ['leaderboard', state.user?.id] }),
  });
}
